"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import { usePathname } from "next/navigation";
import useIsDesktop from "@core/helpers/client/hooks/useIsDesktop";

const ShareModal = dynamic(() => import("./ShareModal"), { ssr: false });


export default function Share({
    link,
    className = "",
    parentClassName = "",
    mobile_icon_size = 18,
    desktop_icon_size = 22,
    show_label = false,
    label = "اشتراک گذاری",
}) {
    const [open, setOpen] = useState(false);
    const [modal_requested, set_modal_requested] = useState(false);
    const pathname = usePathname();
    const is_desktop = useIsDesktop();

    const isBlog = pathname.startsWith("/blog/") || pathname.startsWith("/seller-academy/")

    const [_link, setLink] = useState("");
    const [page_title, setPageTitle] = useState("");

    useEffect(() => {
        setLink(link || window.location.href);
        setPageTitle(document.title);
    }, [link, pathname]);

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    text: "این لینک رو ببین:",
                    url: _link || window.location.href,
                });
            } catch (_) { }
        }
    };

    const label_class = show_label ? "flex items-center gap-1" : "";

    return (
        <>
            {/* mobile */}
            {is_desktop !== true && <div className="block lg:hidden">
                <button
                    onClick={handleNativeShare}
                    aria-label={label}
                    className={`cursor-pointer transition-all ${label_class} ${className}`}>
                    {show_label && <span className="text-[13px]">{label}</span>}
                    <Share2 size={mobile_icon_size} />
                </button>
            </div>}

            {/* desktop  */}
            {is_desktop !== false && <div className={`hidden lg:block ${parentClassName}`}>
                <button
                    onClick={() => { set_modal_requested(true); setOpen(true); }}
                    aria-label={label}
                    className={`cursor-pointer transition-all ${label_class} ${className}`} >
                    <Share2 size={desktop_icon_size} />
                    {show_label && <span className="text-xs font-bold">{label}</span>}
                </button >
            </div>}

            {/* modal: its code loads on the first click */}
            {modal_requested && (
                <ShareModal
                    isOpen={open}
                    onClose={() => setOpen(false)}
                    {...{ link, _link, page_title, isBlog }}
                />
            )}
        </>
    );
}
